import React from 'react'

const ResumeWatchingIcon = ({ color = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.944"
      height="17.26"
      viewBox="0 0 17.944 17.26"
    >
      <g data-name="Group 1170">
        <path
          d="M37.718 7.432 26.767.212C25.8-.429 25 .219 25 1.651v13.887c0 1.433.8 2.08 1.767 1.439l10.95-7.217a1.3 1.3 0 0 0 .001-2.328z"
          transform="translate(-20.5 .035)"
          style={{ fill: color }}
        />
        <path
          data-name="Line 112"
          transform="translate(1 1.129)"
          style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '2px' }}
          d="M0 0v15"
        />
      </g>
    </svg>
  )
}

export default ResumeWatchingIcon
